import PracticeProblemHub from './PracticeProblemHub';

export default PracticeProblemHub;
